import { HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { SESSION_ID } from 'src/session-id';

export function sessionInterceptor(req: HttpRequest<unknown>, next: HttpHandlerFn) {
  for (let index = 0; index < environment.excludeUrls.length; index++) {
    const excludeUrl = environment.excludeUrls[index];
    if (req.url.includes(excludeUrl)) {
      return next(req);
    }
  }

  const requestWithSession = req.clone({
    headers: req.headers.set('sessionId', SESSION_ID),
  });

  return next(requestWithSession);
}
